import script from "./MainInfoSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInfoSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./MainInfoSkeleton.vue?vue&type=style&index=0&id=cf82e71c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf82e71c"]])

export default __exports__